import React from 'react';

import BaseInventoryTag from './BaseInventoryTag';
import * as Icons from '../icons/Icons';


export class InventoryCamping extends BaseInventoryTag { }
InventoryCamping.defaultProps = {
    tagIconName: <Icons.IconTent alt="Camping" />,
    name: "Camping",
    iconClass: "camping"
};

export class InventoryRecArea extends BaseInventoryTag { }
InventoryRecArea.defaultProps = {
    tagIconName: <Icons.IconTree alt="Recreation Area" />,
    name: "Recreation Area",
    iconClass: "rec-area"
};

export class InventoryTicket extends BaseInventoryTag { }
InventoryTicket.defaultProps = {
    tagIconName: <Icons.IconTicket alt="Tickets and Tours" />,
    name: "Tickets & Tours",
    iconClass: "tickets-tours"
};

export class InventoryPass extends BaseInventoryTag { }
InventoryPass.defaultProps = {
    tagIconName: <Icons.IconCard alt="Passes" />,
    name: "Passes",
    iconClass: "pass"
};

export class InventoryPOI extends BaseInventoryTag { }
InventoryPOI.defaultProps = {
    tagIconName: <Icons.IconCompass alt="Point of Interest" />,
    name: "Point of Interest",
    iconClass: "poi"
};

export class InventoryDayUse extends BaseInventoryTag { }
InventoryDayUse.defaultProps = {
    tagIconName: <Icons.IconPicnicTable alt="Day Use" />,
    name: "Day Use",
    iconClass: "day-use"
};

export class InventoryLottery extends BaseInventoryTag { }
InventoryLottery.defaultProps = {
    tagIconName: <Icons.IconLottery alt="Lottery" />,
    name: "Lottery",
    iconClass: "lottery"
};

export class InventoryRental extends BaseInventoryTag { }
InventoryRental.defaultProps = {
    tagIconName: <Icons.IconRental alt="Rental" />,
    name: "Rental",
    iconClass: "rental"
};

export class InventoryPermit extends BaseInventoryTag { }
InventoryPermit.defaultProps = {
    tagIconName: <Icons.IconPermit alt="Permits" />,
    name: "Permits",
    iconClass: "permit"
};

export class InventoryVehiclePermit extends BaseInventoryTag { }
InventoryVehiclePermit.defaultProps = {
    tagIconName: <Icons.IconVehiclePermit alt="Vehicle Permit" />,
    name: "Vehicle Permit",
    iconClass: "vehicle-permit"
};

export class InventoryMapPin extends BaseInventoryTag { }
InventoryMapPin.defaultProps = {
    tagIconName: <Icons.IconPin alt="Map Pin" />,
    name: "Map Pin",
    iconClass: "map-pin"
};